import React from 'react';
import {Link} from '@reach/router';

import {useAuth} from 'context';
import Logo from 'images/plum_logo_white.png';

import {SidebarLink} from './components/SidebarLink';

import * as styles from './Frame.module.css';

export function Frame({children, visible}) {
  const {logout} = useAuth();

  if (!visible) {
    return children;
  }

  return (
    <div>
      <section className={styles.Sidebar}>
        <img src={Logo} className={styles.Logo} alt="Plum" />

        <nav className={styles.QuickLinks}>
          <Link to="/memberships/new" className={styles.QuickLink}>
            New membership
          </Link>
        </nav>

        <nav className={styles.Links}>
          <SidebarLink to="/memberships" partialCurrency>
            Memberships
          </SidebarLink>
          <SidebarLink to="/plans" partialCurrency>
            Plans
          </SidebarLink>
          <SidebarLink to="/settings" partialCurrency>
            Settings
          </SidebarLink>
        </nav>

        <nav className={styles.LogOut}>
          <SidebarLink onClick={logout} to="/" neverActive>
            Log out
          </SidebarLink>
        </nav>
      </section>
      <section className={styles.ContentContainer}>
        <div className={styles.Content}>{children}</div>
      </section>
    </div>
  );
}
